import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css';

const sortedFontOptions = [
  "Arial",
  "Comic Sans MS",
  "Courier New",
  "Impact",
  "Georgia",
  "Tahoma",
  "Trebuchet MS",
  "Verdana",
  "Logical",
  "Salesforce Sans",
  "Garamond",
  "Sans-Serif",
  "Serif",
  "Times New Roman",
  "Helvetica",
].sort();
const sunEditorSettings = {
  buttonList: [
    ["undo", "redo"],
    ["font", "fontSize"],
    // ['paragraphStyle', 'blockquote'],
    [
      "bold",
      "underline",
      "italic",
      "strike",
      "subscript",
      "superscript"
    ],
    ["fontColor", "hiliteColor"],
    ["align", "list", "lineHeight"],
    ["outdent", "indent"],

    ["table", "horizontalRule"],
    // ['math'] //You must add the 'katex' library at options to use the 'math' plugin.
    // ['imageGallery'], // You must add the "imageGalleryUrl".
    // ["fullScreen", "showBlocks", "codeView"],
    ["preview", "print"],
    ["removeFormat"]

    // ['save', 'template'],
    // '/', Line break
  ], // Or Array of button list, eg. [['font', 'align'], ['image']]
  defaultTag: "div",
  minHeight: "300px",
  showPathLabel: false,
  font: sortedFontOptions
};
interface IEditor {
  name?: string,
  value?: string,
  disable?: boolean,
  handleChange?: (e: string) => void,
}

export const JVSunEditor = (props: IEditor) => {
  return (
    <SunEditor
      setContents={props.value}
      name={props.name}
      onChange={props.handleChange}
      disable={props.disable}
      setOptions={sunEditorSettings}
    />
  )
}